/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantBatchResponse {
    getFixupPrototypeFunction() { return TenantBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<TenantBatchResponse>): TenantBatchResponse {
        let obj = Object.assign(new TenantBatchResponse(), model);
        TenantBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantBatchResponse>): TenantBatchResponse {
        if (!model) return null;
        return TenantBatchResponse.newInstance(<TenantBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantBatchResponse) {
        if (!obj) return;

        models.TenantBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantBatchResponse): boolean {
        Object.setPrototypeOf(obj, TenantBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TenantDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TenantDetails; };

}
